import { render, staticRenderFns } from "./power.vue?vue&type=template&id=270c4196&scoped=true"
import script from "./power.vue?vue&type=script&lang=js"
export * from "./power.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c4196",
  null
  
)

export default component.exports